import { Tabs } from '@mantine/core'
import { ContextModalProps } from '@mantine/modals'
import DispatchParcelsTable from 'components/orders/DispatchParcelsTable'
import { DeliveryCompanyName } from 'types/orders'

type Props = {
  selectedOrderIds: Array<number>
}

export default function DispatchParcelsModal({ innerProps: { selectedOrderIds } }: ContextModalProps<Props>) {
  return (
    <Tabs defaultValue={DeliveryCompanyName.InPost} mb="md">
      <Tabs.List>
        {Object.entries(DeliveryCompanyName).map(([key, company]) => (
          <Tabs.Tab key={key} value={key} disabled={isDeliveryCompanyDisabled(company)}>
            {company}
          </Tabs.Tab>
        ))}
      </Tabs.List>

      {Object.entries(DeliveryCompanyName).map(([key, company]) => (
        <Tabs.Panel key={key} value={key}>
          <DispatchParcelsTable deliveryCompanyName={company} selectedOrderIds={selectedOrderIds} />
        </Tabs.Panel>
      ))}
    </Tabs>
  )
}

export function isDeliveryCompanyDisabled(name: DeliveryCompanyName) {
  return name === DeliveryCompanyName.Poczta
}
